
const printButtons = document.querySelectorAll("[data-print-block-id]");

// Event listeners for print buttons in custom Gutenberg block
printButtons.forEach((element, index, elements) => {

    element.addEventListener('click', function(el) {
        let id = element.getAttribute('data-print-block-id');
        printElement(id);
    });
});

function printElement(id) {
    if (!id) {
        window.print();
    } else {
        let printContents = document.getElementById(id).innerHTML;
        w = window.open();
        w.document.write(printContents);
        w.print();
        w.close();
    }
}
